module.exports = __webpack_public_path__ + "static/media/hmfront.53af6eac.png";